/**
 * @description "Именнованное простарнство" для разделения ресурсов различных приложений(платформ)
 */
export enum NamespaceType {
  METADOOR = 'metadoor',
  RSHB = 'rshb',
}

type NamespaceKey = keyof typeof NamespaceType; // 'RSHB' | 'METADOOR'

/**
 * @description значения для определения типа пространства по коду
 * @variation 'metadoor' | 'rshb'
 */
export type INamespace = (typeof NamespaceType)[NamespaceKey]; //  'metadoor' |'rshb'
